const CHALLENGE_INITIAL_STATE = {
  isFetchLoading: false,
  isSimpleDetailsLoading: false,
  isRelationsDetailsLoading: false,
  fetchError: undefined,
  simpleDetailsError: undefined,
  relationsDetailsError: undefined,
  data: undefined,
  isRelationsDirty: false,
  isSimpleDetailsDirty: false,
  isImageDetailsLoading: false,
  imageDetailsError: undefined,
}

export default CHALLENGE_INITIAL_STATE
